export default {
    props: {
        messagesChecked: {
            type: String,
            kComposite: 'messages.checked'
        }, 
        messagesUnchecked: {
            type: String,
            kComposite: 'messages.unchecked'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/Messages.js